import { ArrowLeft } from "lucide-react";
import { ReactNode } from "react";

interface IEditorToolModalHeader {
  backFn: () => void;
  isEditing: boolean;
}

const EditorToolModalHeader = ({
  backFn,
  isEditing,
}: IEditorToolModalHeader): ReactNode => {
  return (
    <header className="w-[calc(100%+12px)] bg-zarc-neutral-gray h-full max-h-[65px] tablet:max-h-[100px] min-h-[65px] tablet:min-h-[100px] flex items-center justify-between relative -top-1 -left-1 px-8 tablet:px-16">
      <button onClick={backFn}>
        <ArrowLeft color="#313131" size={32} />
      </button>

      <h2 className="text-heading-xs">
        {isEditing ? "Editar Ferramenta" : "Nova Ferramenta"}
      </h2>

      <div />
    </header>
  );
};

export default EditorToolModalHeader;
